export default __webpack_public_path__ + "static/Hybrid-Cloud-3c38382b3e5f924f43cd3085dfbef5c0.webp";